"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledAccordian = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// External
var StyledAccordian = _styledComponents.default.div.withConfig({
  displayName: "Accordionstyles__StyledAccordian",
  componentId: "sc-4brv1q-0"
})(["background-color:", ";margin:", " 0;"], function (props) {
  return props.theme.c_background_default;
}, function (props) {
  return props.theme.standardPadding;
});

exports.StyledAccordian = StyledAccordian;